export const englishTestArticle = {
  slug: "english-test",
  number: "01-2",
  icon: "ri-translate-2",
  category: "コミカレの始め方",
  parentSlug: "community-college",
  parentLabel: "コミカレの始め方",
  title: "英語力証明試験",
  lead: "コミカレ出願で使われるTOEFL iBT・Duolingo English Test・IELTS Academicの目的と仕組み、出願時の使われ方、公式情報の確認方法、そしてTSIA2との違いを整理しました。",
  updatedAt: "2026.10.26",
  blocks: [
    {
      kind: "note",
      title: "このページについて",
      text: "試験の基本情報をまとめた無料記事です。受け付ける試験の種類・最低スコア・免除条件は学校ごとに異なります。当サイトでは学校別の基準を推測で掲載せず、必ず志望校の公式サイトで確認する前提で説明しています。",
    },
    { kind: "h", text: "英語力証明試験は「入学のための語学力の証明」" },
    {
      kind: "p",
      text: "アメリカの大学・コミカレに出願するとき、授業についていける英語力があるかを示すために、英語力証明試験のスコアを求められることがあります。TOEFL iBT、IELTS Academic、Duolingo English Test が代表的な選択肢です。",
    },
    {
      kind: "p",
      text: "ここで大切なのは、「どの試験でもよい」わけではないという点です。学校が指定する試験を受ける必要があり、求められるスコアも学校ごとに違います。まず志望校の留学生向けページで「Accepted English proficiency tests」を確認するのが最初の一歩です。",
    },
    {
      kind: "cards",
      items: [
        {
          icon: "ri-file-text-line",
          title: "TOEFL iBT",
          text: "ETSが実施する、大学留学で広く使われる4技能の試験。2026年1月から1〜6のスコア尺度に変更されました。",
        },
        {
          icon: "ri-computer-line",
          title: "Duolingo English Test（DET）",
          text: "自宅のパソコンで受験できるオンラインの試験。対応校は増えていますが、すべての学校が受け付けるわけではありません。",
        },
        {
          icon: "ri-global-line",
          title: "IELTS Academic",
          text: "0〜9のバンドで評価される4技能の試験。アカデミック目的の「Academic」が留学・出願で使われます。",
        },
      ],
    },
    { kind: "h", text: "TOEFL iBTの基本と2026年からのスコア尺度" },
    {
      kind: "p",
      text: "TOEFL iBTは、Reading（読む）・Listening（聞く）・Speaking（話す）・Writing（書く）の4技能を測る試験です。テストセンターでの受験に加えて、自宅で受験する形式も用意されています。",
    },
    {
      kind: "list",
      items: [
        "実施機関：ETS（Educational Testing Service）",
        "評価：4技能それぞれと総合スコア",
        "2026年1月21日以降：1〜6の尺度（0.5刻み）で表示",
        "総合スコア：4技能の平均をもとに0.5刻みで算出される",
        "移行期間：2026年1月から約2年間、従来の0〜120の互換スコアもあわせて表示される",
        "スコアの有効期間：一般に2年（受付期間は学校が定める）",
        "申込・日程・料金・会場：ETSの公式サイトで確認",
      ],
    },
    {
      kind: "note",
      title: "2026年1月からの新しい尺度（1〜6）",
      text: "ETSは2026年1月21日から、TOEFL iBTのスコア尺度を従来の0〜120から1〜6（0.5刻み）に変更しました。4技能と総合スコアのすべてが1〜6で表示されます。CEFRとの対応が分かりやすくなった一方、学校側の募集要項が旧尺度のままの期間もあるため、出願時は「どちらの尺度で書かれた基準か」を必ず確認してください。",
    },
    {
      kind: "table",
      head: ["TOEFL iBT（1〜6）", "CEFRの目安", "位置づけ"],
      rows: [
        ["6.0", "C2", "高度な学術英語を使いこなせる水準"],
        ["5.0〜5.5", "C1", "上級。大学院などで求められることが多い水準"],
        ["4.0〜4.5", "B2", "中上級。学部留学で求められることが多い水準"],
        ["3.0〜3.5", "B1", "中級。基礎的な英語運用ができる水準"],
        ["2.0〜2.5", "A2", "初級。日常的な表現が中心の水準"],
        ["1.0〜1.5", "A1", "入門。初歩的な英語の水準"],
      ],
    },
    {
      kind: "note",
      title: "この表は「目安」です",
      text: "上の対応はETSが公表している尺度とCEFRの関係をもとにした目安です。学校が求めるスコアは、これとは別に学校・専攻ごとに設定されます。当サイトでは学校別の基準値を掲載していません。",
    },
    { kind: "h", text: "Duolingo English Test（DET）の基本" },
    {
      kind: "p",
      text: "Duolingo English Testは、自宅のパソコンとネット環境で受験できるオンラインの英語力試験です。短時間で受験でき、結果も比較的早く届くため、出願時期が迫っている場合の選択肢になります。",
    },
    {
      kind: "list",
      items: [
        "受験方法：自宅でオンライン（カメラ・マイクなどの環境条件あり）",
        "所要時間：約1時間程度",
        "評価：10〜160のスコア（5点刻み）と、技能別の内訳",
        "結果：受験後にオンラインで確認（公式サイトに目安が案内されている）",
        "スコアの有効期間：一般に2年（受付期間は学校が定める）",
        "申込・料金・環境要件：Duolingo English Testの公式サイトで確認",
      ],
    },
    {
      kind: "note",
      title: "すべてのコミカレが受け付けるわけではありません",
      text: "Duolingo English Testは対応校が増えていますが、受け付けるかどうかは学校ごとに異なります。コミカレによってはTOEFL iBTやIELTS Academicのみを受理する場合があるため、必ず志望校の公式ページで確認してください。",
    },
    { kind: "h", text: "IELTS Academicの基本" },
    {
      kind: "p",
      text: "IELTSは、Listening（聞く）・Reading（読む）・Writing（書く）・Speaking（話す）の4技能を測る試験です。留学・高等教育機関への出願には、アカデミック向けの「IELTS Academic」が使われます。",
    },
    {
      kind: "list",
      items: [
        "評価：4技能と総合を0〜9のバンド（0.5刻み）で表示",
        "受験方法：テストセンターでのペーパー形式・コンピューター形式、または自宅受験の形式が用意されている地域がある",
        "Speaking：面接形式で実施される",
        "スコアの有効期間：一般に2年（受付期間は学校が定める）",
        "申込・日程・料金・会場：IELTS公式サイト、または実施機関の案内で確認",
      ],
    },
    {
      kind: "note",
      title: "General Trainingと間違えないように",
      text: "IELTSには「Academic」と「General Training」があります。大学・コミカレへの出願で使うのは、原則としてAcademicです。募集要項にどちらが書かれているかを確認してください。",
    },
    { kind: "h", text: "学校ごとに「受付・基準・免除」が異なります" },
    {
      kind: "list",
      items: [
        "受け付ける試験の種類（TOEFL iBTのみ、IELTSも可、DETも可など）",
        "求められる最低スコア（総合だけでなく、技能別の下限が設定されることもある）",
        "スコアの有効期限（出願時点で2年以内など）",
        "免除の条件（英語で学位を取得した場合、指定のプログラムを修了した場合など）",
        "条件付き入学（conditional admission）や語学プログラムからの開始が用意されているか",
        "スコアの提出方法（公式スコアの送付が必要か、コピーでよいか）",
      ],
    },
    {
      kind: "pending",
      title: "学校別のスコア基準（情報確認中）",
      text: "学校ごとの最低スコアや免除条件は、公式ページで確認できたものから掲載します。推測で数値を載せることはしません。現在は情報確認中です。",
    },
    { kind: "h", text: "TOEFL・DET・IELTSとTSIA2は目的が違います" },
    {
      kind: "p",
      text: "この2つはよく混同されますが、役割がまったく異なります。英語力証明試験は「入学審査のための語学力の証明」、TSIA2は「入学後にどの授業から始めるかを決めるためのプレイスメントテスト」です。",
    },
    {
      kind: "table",
      head: ["試験", "主な目的", "使われ方"],
      rows: [
        ["TOEFL iBT / IELTS Academic / DET", "英語力の証明", "出願時の書類として提出し、入学審査で使われる"],
        ["TSIA2（TSI Assessment 2.0）", "大学レベルの授業への準備状況の確認", "テキサス州の公立校で、入学後の授業配置（補習が必要かなど）に使われる"],
      ],
    },
    {
      kind: "p",
      text: "TSIA2は合否を決める入学試験ではなく、ELAR（読解・文章作成）と数学の準備状況を確認する試験です。留学生の場合、英語力証明試験の提出に加えてTSIA2の受験が必要になることがあります。必要な試験とタイミングは学校ごとに異なるため、入学予定校の案内を確認してください。",
    },
    {
      kind: "cta",
      title: "TSIA2の詳細はこちらの記事へ",
      text: "TSIA2の位置づけ、分野、基準点の考え方、基準に届かなかった場合の対応をまとめています。",
      to: "/learn/tsi",
      label: "TSI（TSIA2）対策を読む",
    },
    { kind: "h", text: "無料で公開していること・有料ガイドで扱うこと" },
    {
      kind: "p",
      text: "試験の基本情報、出願条件の確認方法、公式情報への案内は、このページですべて無料で読めます。一方、独自に作った学習計画表や問題、学校比較のテンプレートは、有料PDFガイドとしてまとめる予定です。現在はすべて準備中のため購入できません。",
    },
    {
      kind: "cta",
      title: "有料ガイド（準備中）",
      text: "TSIA2対策・日本語解説ガイドでは、学習計画表や独自の練習問題を扱う予定です。完成までは購入できません。",
      to: "/guides",
      label: "有料ガイド一覧を見る",
    },
    {
      kind: "pending",
      title: "学習計画表（準備中）",
      text: "試験日から逆算した学習計画表と、復習チェックリストを有料ガイドとして準備しています。内容を確認できた段階で公開します。",
    },
    {
      kind: "source",
      items: [
        {
          label: "ETS — TOEFL iBT Scores（Understand Your Scores）",
          url: "https://www.ets.org/toefl/test-takers/ibt/scores/understand-scores.html",
          checkedAt: "2026.10.26",
          terms: "ETS公式ページ。尺度と評価方法の確認に使用し、文章・図表の転載は行っていません。",
        },
        {
          label: "ETS — TOEFL iBT Score Scale Update（1〜6 scale）",
          url: "https://www.ets.org/toefl/institutions/ibt/score-scale-update.html",
          checkedAt: "2026.10.26",
          terms: "ETS公式ページ。2026年1月の尺度変更の確認に使用しています。",
        },
        {
          label: "Duolingo English Test（公式サイト）",
          url: "https://englishtest.duolingo.com/",
          checkedAt: "2026.10.26",
          terms: "公式サイト。受験方法・料金・環境要件はこちらで確認してください。転載は行っていません。",
        },
        {
          label: "Duolingo English Test — Accepting Institutions",
          url: "https://englishtest.duolingo.com/test_takers/accepting_institutions",
          checkedAt: "2026.10.26",
          terms: "公式の対応校検索ページ。学校ごとの受付状況はこちらと志望校公式の両方で確認してください。",
        },
        {
          label: "IELTS（公式サイト）",
          url: "https://ielts.org/",
          checkedAt: "2026.10.26",
          terms: "IELTS公式サイト。試験形式・日程・料金の確認に使用しています。",
        },
        {
          label: "テキサス州高等教育委員会（THECB）— Texas Success Initiative",
          url: "https://www.highered.texas.gov/texas-success-initiative/",
          checkedAt: "2026.10.26",
          terms: "州の公式ページ。TSIA2の位置づけの確認に使用しています。",
        },
      ],
    },
  ],
};